import { _AdvertiseImgIndividualBase as AdvertiseImgIndividualBase } from './cssVar/advertiseImgIndividualBase'
import { _AdvertiseImgIndividualDefault as AdvertiseImgIndividualDefault } from './cssVar/advertiseImgIndividualDefault'
import { _AdvertiseImgIndividualSmall as AdvertiseImgIndividualSmall } from './cssVar/advertiseImgIndividualSmall'
import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { CardDefaultBgImg } from '../class/cardDefaultBgImg'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { LandscapeProps } from '../../components/basePropsConfig'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type AdvertiseImgIndividualCssVarManager =
  GetCssVarManager<AdvertiseImgIndividualBase>
export {
  AdvertiseImgIndividualBase,
  AdvertiseImgIndividualDefault,
  AdvertiseImgIndividualSmall
}

/** 完整独立的一张广告图片 */
@Component<AdvertiseImgIndividual>({
  name: 'AdvertiseImgIndividual'
})
export default class AdvertiseImgIndividual extends Mixins<
  Base<unknown, unknown, unknown>,
  BaseCssVarInject<AdvertiseImgIndividualBase>
>(Base, BaseCssVarInject) {
  /** 获得默认样式cssVar */
  public static getCssVarDefault = () => new AdvertiseImgIndividualDefault()
  /** 获得小号样式cssVar */
  public static getCssVarSmall = () => new AdvertiseImgIndividualSmall()

  @Inject('cardProps') cardProps!: Required<LandscapeProps>

  render() {
    const { imgUrl, bgImg, categoryId } = this.cardProps
    return (
      <my-img
        class={{
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType),
          [style['advertse-img-individual']]: true
        }}
        options={{ type: 'div' }}
        src={bgImg || CardDefaultBgImg.getBgImg(categoryId as GameCategoryIds)}
      >
        {/* 完整的广告图 */}
        <my-img
          class={style['aImg-complete']}
          src={imgUrl}
          options={{ type: 'div' }}
        ></my-img>
      </my-img>
    )
  }
}
